import React, { useState, useEffect } from 'react';

function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('home');

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 100);
            
            // Update active nav link based on scroll position
            const sections = document.querySelectorAll('section[id]');
            let currentSection = 'home';
            
            sections.forEach(section => {
                const sectionTop = section.offsetTop - 100;
                const sectionHeight = section.offsetHeight;
                if (window.pageYOffset >= sectionTop && window.pageYOffset < sectionTop + sectionHeight) {
                    currentSection = section.getAttribute('id');
                }
            });
            
            setActiveSection(currentSection);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            const offsetTop = target.offsetTop - 80;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
        setMobileMenuOpen(false);
    };

    return (
        <header id="header" className={`header ${scrolled ? 'scrolled' : ''}`}>
            <nav className="navbar">
                <div className="container">
                    <div className="nav-wrapper">
                        <div className="logo">
                            <a href="#home" onClick={(e) => handleNavClick(e, '#home')}>
                                <img src="/images/logo.png" alt="GraceTech 로고" className="logo-img" />
                                <span className="logo-text">은혜테크</span>
                            </a>
                        </div>
                        
                        <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`} id="navMenu">
                            <li><a href="#home" className={`nav-link ${activeSection === 'home' ? 'active' : ''}`} onClick={(e) => handleNavClick(e, '#home')}>홈</a></li>
                            <li><a href="#about" className={`nav-link ${activeSection === 'about' ? 'active' : ''}`} onClick={(e) => handleNavClick(e, '#about')}>회사소개</a></li>
                            <li><a href="#services" className={`nav-link ${activeSection === 'services' ? 'active' : ''}`} onClick={(e) => handleNavClick(e, '#services')}>사업영역</a></li>
                            <li><a href="#partners" className={`nav-link ${activeSection === 'partners' ? 'active' : ''}`} onClick={(e) => handleNavClick(e, '#partners')}>협력사</a></li>
                            <li><a href="#portfolio" className={`nav-link ${activeSection === 'portfolio' ? 'active' : ''}`} onClick={(e) => handleNavClick(e, '#portfolio')}>포트폴리오</a></li>
                            <li><a href="#contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`} onClick={(e) => handleNavClick(e, '#contact')}>문의하기</a></li>
                        </ul>
                        
                        <div 
                            className={`hamburger ${mobileMenuOpen ? 'active' : ''}`} 
                            id="hamburger"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header;
